<div class="impact-dashboard-container">
  <!-- Hero Section: Ready to unlock your first win? -->
  <div class="hero-section">
    <div class="hero-icon">
      <img src="assets/icons/rocket-icon.svg" alt="Rocket" class="rocket-icon" />
    </div>
    <div class="hero-content">
      <h1>Ready to unlock your first win?</h1>
      <p>
        Start testing with PDQ and discover data-driven opportunities to boost your revenue. Our AI-powered platform
        identifies the highest-impact tests for your business.
      </p>
      <pdq-button variant="secondary" (onClick)="onStartFirstTest()">
        Start Your First Test
        <pdq-icon icon="side_right_arrow" size="small"></pdq-icon>
      </pdq-button>
    </div>
  </div>

  <!-- MAXX AI Assistant Section -->
  @if (isMaxxEnabled) {
    <div class="maxx-section">
      <div class="maxx-header">
        <img src="assets/icons/maxx_chat.svg" alt="MAXX Chat" class="maxx-chat-logo" />
      </div>

      <div class="maxx-chat-input-container">
        <div class="maxx-chat-bg"></div>
        <div class="maxx-chat-input-wrapper">
          <input
            type="text"
            class="maxx-chat-input"
            placeholder="Ask Maxx anything"
            [(ngModel)]="chatInput"
            (keydown)="onKeyDown($event)" />
          <button class="maxx-send-button" (click)="onSendMessage()" [disabled]="!chatInput.trim()">
            <img src="assets/icons/up_arrow.svg" alt="Send" />
          </button>
        </div>
      </div>

      <div class="suggested-prompts">
        @for (prompt of suggestedPrompts; track prompt) {
          <button class="prompt-chip" (click)="onSuggestedPromptClick(prompt)">
            {{ prompt }}
          </button>
        }
      </div>
    </div>
  }

  <!-- Strategy Catalog Section -->
  <div class="recipe-section">
    <div class="recipe-header">
      <div class="recipe-title-area">
        <h2>Strategy Catalog</h2>
        <p>Proven ideas to accelerate your growth</p>
      </div>
      <pdq-button variant="secondary" (onClick)="onViewAllStrategies()">
        View All Strategies
        <pdq-icon icon="side_right_arrow" size="small"></pdq-icon>
      </pdq-button>
    </div>

    @if (loadingStrategies) {
      <div class="recipe-cards-loading">
        <skeleton-strategy-catalog [numOfCards]="9"></skeleton-strategy-catalog>
      </div>
    } @else {
      <div class="recipe-cards">
        @for (item of recipeStrategies; track item[StrategyColumns.ID]) {
          <div class="recipe-card" (click)="navigateToStrategyDetails(item)">
            <div class="recipe-card-header">
              <p class="category-badge" [ngClass]="optimizeCategoryName(item)">
                {{ item[StrategyColumns.PRIMARY_CATEGORY] }}
              </p>
              <h4>{{ item[StrategyColumns.NAME] }}</h4>
            </div>
            <div class="recipe-card-content">
              <p>{{ item[StrategyColumns.CONCEPT] }}</p>
            </div>
            <div class="recipe-card-kpi">
              <p class="kpi-label">Main KPIs:</p>
              <div class="kpi-tags">
                @for (kpi of getKpiTargetsList(item); track $index) {
                  <span class="kpi-tag">{{ kpi }}</span>
                }
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
